import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { bindKeymapWithCommand, addInlineComment } from '../../../keymaps';
import { setInlineCommentDraftState } from '../commands';
import { INPUT_METHOD } from '../../analytics';
export function keymapPlugin() {
  var list = {};
  bindKeymapWithCommand(addInlineComment.common, setInlineCommentDraftState(true, INPUT_METHOD.SHORTCUT), list);
  return keymap(list);
}